var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ec-container"},[_c('div',{ref:_vm.id,style:({ width: _vm.width, height: _vm.height })})])
}
var staticRenderFns = []

export { render, staticRenderFns }